import { ChromeAppMessage } from 'Environment/ChromeApp/types';
import { clientType } from 'Environment/getClientType';
import { postMessageToChromeApp } from 'Environment/launchResource/chromeApp';
import { Dependencies } from 'GlobalAppConfigService/types';
import { wsuiDependencies } from 'GlobalAppConfigService/wsuiDependencies';
import { GacsHtmlChromeAppTransportBase } from './gacsTransportBase';

export class GacsChromeAppTransport extends GacsHtmlChromeAppTransportBase {
	private constructor(dependencies: Dependencies) {
		super(dependencies, clientType.chromeapp);
	}

	protected postMessage(message: ChromeAppMessage): void {
		postMessageToChromeApp(message);
	}

	private static instance: GacsChromeAppTransport;

	// Unlike the Html5Trasport, we use a singleton pattern for ChromeAppTransport
	// This is because the Html5Trasport gets a new instance HTML5Client which ChromeAppTransport does not need,
	public static getInstance(): GacsChromeAppTransport {
		if (!GacsChromeAppTransport.instance) {
			GacsChromeAppTransport.instance = new GacsChromeAppTransport(wsuiDependencies);
		}
		return GacsChromeAppTransport.instance;
	}
}
